// extracted by mini-css-extract-plugin
export default {"label":"DuplicateMenuItemModal_label__Ts9nV"};